























import { Component, Prop, Vue } from 'vue-property-decorator';
import Category from '../../logic/model/Category';
import Article from '../../logic/model/Article';
import ArticleItem from './ArticleItem.vue'
import _ from 'lodash'


@Component({
    components: {
        ArticleItem
    }
})
export default class CategoryCard extends Vue {
    @Prop()
    category!:Category;

    private isExpanded:Boolean = true;
    private search:String = "";

    get filteredArticles() {

        if (this.search !== "") {
            let searchString = this.search.toLowerCase()
            return this.category.$articles.filter( item => {
                return item.$name.toLowerCase().includes(searchString) ||
                item.$number.toString().includes(searchString) ||
                item.$description.toLowerCase().includes(searchString)
            })
        }

        return this.category.$articles
    }

    ordered(data:any) {
        this.$emit('ordered',data)
    }

    getSizes(article:Article) {
        let sizes = [];
        for (const size of article.$prices) {
            sizes.push(size.$name);
        } 
        return sizes;
    }
    
}
